var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// /code/frontend/~/core-js/modules/_has.js
// module id = ../../../../core-js/modules/_has.js
// module chunks = 0